import {initNavbar} from '../common';
import {formatPrice} from '../common';
import "jquery-validation";
import "jquery-ui-dist/jquery-ui.js";
import "foundation-sites";
import "slick-carousel";
import "jquery-mousewheel";
import "jquery.browser";
import "malihu-custom-scrollbar-plugin";
import "jquery-inputmask";
import "bootstrap";
import AuthPass from "../auth/auth-pass";

(function ($) {
  "use strict";
  window.$ = window.jQuery = $;

  let branchesHideOnlinePay = {};
  let branchesDelivery = '';

  function getBranchesHideOnlinePay() {
    $.ajax({
      type: "POST",
      url: "/ajax/getBranchesHideOnlinePay.php",
      dataType: "json",
      success: function (data) {
        $.each(data.result, function (key, val) {
          branchesHideOnlinePay[val] = "Y";
        })
      },
    });
  }

  let order = {},
    orderNumberInterval = [],
    sum_delivery = 0,
    myMap,
    typeAddress,
    typeAddressPopup,
    orderResult,
    selected = false,
    housetime = false,
    smsAgain = null,
    houseMask = /\D*([0-9]+[a-zA-Zа-яА-Я]{0,1}[\/]?[0-9]+[a-zA-Zа-яА-Я]{0,1})(.*)/;


  getBranchesHideOnlinePay();
  /**
   * Автоматические проставление самовывоза при выборе адреса в шапке
   */
  $(document).ready(function () {
    if ($('#order_form').data('address-self-pickup') === 'Y') {
      setTimeout(function () {
        $('#order_form').find('#come_button')[0].click();
        $('.address[data-pickup="1"]')[0].click();
      }, 1000);
    }
  })


  window.updateStopList = function (guid) {

    let $stopListItemsWrapper = $(document).find('#stop-list-order-wrapper');
    if ($stopListItemsWrapper.length === 0) {
      $(document).find('[data-entity="order-next-step"]').css('display', 'block');
      return;
    }
    $(document).find('[data-entity="order-next-step"]').css('display', 'none');
    $(document).find('#disabled-stop-list').parent('.reveal-overlay').remove();
    $(document).find('#stop-list-order-popup').parent('.reveal-overlay').remove();

    console.trace();
    $.ajax({
      method: 'GET',
      url: '/ajax/stopListProvider.php',
      data: {'is-cart': 'Y', 'action': 'reload', 'guid': guid, 'custom-id': 'stop-list-order-popup', 'reload': 'Y'},
      cache: false,
      contentType: 'json',
      dataType: 'html',
      success: function (data) {
        $(document).find('#disabled-stop-list').parent('.reveal-overlay').remove();
        $(document).find('#stop-list-order-popup').parent('.reveal-overlay').remove();
        $stopListItemsWrapper.html(data);
        if ($stopListItemsWrapper.find('#stop-list-order-popup').length === 1) {
          $(document).find('[data-entity="order-next-step"]').css('display', 'none');
          let $stopListPopupReloaded = $stopListItemsWrapper.find('#stop-list-order-popup');
          //Foundation.reflow($stopListPopupReloaded, 'reveal');
          $stopListPopupReloaded.foundation();
          $stopListPopupReloaded.foundation('open');
        } else {
          $(document).find('[data-entity="order-next-step"]').css('display', 'block');
        }
      },
      error: function (data) {
        console.log(data);
      }
    });

  }


  /** Сохраняет адрес  */
  function saveAddress() {
    try {
      if ($(document).find('#address').val()
        && $(document).find('#house').val()) {
        $.ajax({
          url: '/ajax/user-location.php',
          dataType: 'json',
          data: {
            action: 'checkLocation',
            address: $(document).find('#address').val(),
            house: $(document).find('#house').val(),
            housing: ''
          },
          success: res => {

          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  // Помечает активным текущий шаг
  function markStep(stepID) {
    let steps = $('[data-mark-step!=""][data-mark-step]');
    steps.removeClass('graph__active');
    $('[data-mark-step="' + stepID + '"]').addClass('graph__active');
  }

  //Отрисовка карты
  function init_map(address, div_id) {
    $('#' + div_id).empty();
    $('#' + div_id).append('<div class="loader" title="Пожалуйста, подождите ...">\n' +
      '                                <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>\n' +
      '                            </div>');

    address = address.replace('г Москва', 'Москва');
    if (address.indexOf('Москва') + 1 === 0) {
      address = "Москва " + address;

    }
    try {
      window['ymaps'].geocode(address, {
        results: 1
      }).then(function (res) {
        if (myMap) {
          myMap.destroy();// Деструктор карты
          myMap = null;
        }
        // Выбираем первый результат геокодирования.
        let firstGeoObject = res.geoObjects.get(0),
          // Координаты геообъекта.
          coords = firstGeoObject.geometry.getCoordinates(),
          // Область видимости геообъекта.
          bounds = firstGeoObject.properties.get('boundedBy');

        myMap = new ymaps.Map(div_id, {
          center: coords,
          zoom: 14,
          controls: ["fullscreenControl"]
        });
        firstGeoObject.options.set('preset', 'islands#darkBlueDotIconWithCaption');
        // Получаем строку с адресом и выводим в иконке геообъекта.
        firstGeoObject.properties.set('iconCaption', firstGeoObject.getAddressLine());

        // Добавляем первый найденный геообъект на карту.
        myMap.geoObjects.add(firstGeoObject);
        // Масштабируем карту на область видимости геообъекта.
        myMap.setBounds(bounds, {
          // Проверяем наличие тайлов на данном масштабе.
          // checkZoomRange: true,
          duration: 2000
        });
        myMap.setZoom(14);
      });

      $('#' + div_id).show();
    } catch (e) {
      console.log(e)
    }

  }

  function sendForm() {
    let isFinalStand = $('#step_3').css('display') !== 'none';
    if (isFinalStand) {
      order = {
        ADDRESS: order.ADDRESS,
        NAME: $('input[name=name]').val(),
        PHONE: $('input[name=phone]').val(),
        MAIL: $('input[name=email]').val(),
        payment_type: $('#payment_type').text(),
        payment_id: $('#payment_type').find('span').attr('pay_id'),
        CHANGE: $('#change').text(),
        COL_PERSONS: $('input[name=number]').val(),
        COMMENT: $('textarea[name=comment]').val(),
        ROISTAT_ID: $('input[name=ROISTAT_ID]').val(),
        CONFIRMED: $('input[name=CONFIRMED]').val(),
        ECHEQUE: $('#echeque').is(':checked') ? 'Y' : 'N',
        ORDER_DELIVERIES: order.orderDeliveriesInfo,

        NUMBER_OF_CUTLERY: $(document).find('input[name=cutlery-text]').val(),
        NUMBER_OF_CUTLERY_FORKS: $(document).find('input[name=cutlery-forks]').val(),
        NUMBER_OF_CUTLERY_SPOONS: $(document).find('input[name=cutlery-spoons]').val(),
        NUMBER_OF_CUTLERY_KNIVES: $(document).find('input[name=cutlery-knives]').val(),
      };
      hideOrderButtons();
      $('#loader-result').show();
      reloadOrderList();
    }
  }


  function reloadMinBasket() {
    $.ajax({
      url: '/ajax/miniBasketList.php',
      success: function (res) {
        $('.modalcont').html(res);
      }
    });
  }

  window.reloadMinBasket = reloadMinBasket;

  function showOrderStatus(orderIndex) {
    if (getCurrentOrderIndex() == orderIndex) {
      showOrderSuccessProgressByIndex(orderIndex);
    }
  }

  function showOrderSuccessProgressByIndex(orderIndex) {
    $('[data-entity="cart-order-number-value"]').html(orderResult.data[orderIndex]['status']);
    let $orderNumberWrapper = $('[data-entity="cart-order-number-wrapper"]');
    if ($orderNumberWrapper.length) {
      $orderNumberWrapper.fadeIn(300);
    }
  }

  window.showOrderSuccessProgressByIndex = showOrderSuccessProgressByIndex;

  function getCurrentOrderIndex() {
    return $('.js-basket-menu-day.day_active').data('id');
  }

  function reloadOrderList() {

    $.ajax({
      url: '/ajax/orderList.php',
      success: function (res) {
        $.ajax({
          type: $('#order_form').attr("method"),
          url: $('#order_form').attr("action"),
          data: order,
          dataType: "json",
          success: function (data) {
            if (data.data.status == "error") {
              // заказ запрещен
              location.replace("/personal/cart/#orderStartModalOrder");
            } else {
              try {
                // dataLayer.push({'event': 'formsend'});
              } catch (e) {
                console.log(e);
              }

              reloadBasket(false, false);
              reloadMinBasket();

              orderResult = data;
              window.orderStepSuccess = true;

              if (order.payment_id == 8) {
                var preOrderIDs = []; //LL Get order IDs
                $.each(data.data, function (index, value) {
                  preOrderIDs.push(value.orderId); //LL Get order IDs
                });

                $.ajax({
                  url: '/ajax/getPaymentAlfa.php?orderId=' + preOrderIDs.join('_'),
                  method: 'GET'
                }).done(function (data) {
                  var showPayment = false;

                  try {
                    JSON.parse(data);
                  } catch (e) {
                    showPayment = true;
                  }

                  if (showPayment) {
                    document.location.href = '/personal/order-result/?ORDER_ID=' + preOrderIDs[0];
                  } else {
                    console.log(data);
                  }
                });

                return false;
              } else {
                $('#loader-result').hide();
              }

              $('.step-result-hide').hide();
              $('.step-result-show').show();
              /*LL Hide OrderFinal PopUp for Alfa Payment START*/
              if (order.payment_id != 8) {
                $('#orderFinalModal').foundation();
                $('#orderFinalModal').foundation("open");
              }
              /*LL Hide OrderFinal PopUp for Alfa Payment END*/

              let $deliveryAddressBtn = $('.js-order-delivery-address-btn'),
                $deliveryTimeBtn = $('.js-order-delivery-time-btn');

              $deliveryAddressBtn.removeAttr('data-open');
              $deliveryTimeBtn.removeAttr('data-open');

              $deliveryAddressBtn.addClass('no-cursor');
              $deliveryTimeBtn.addClass('no-cursor');
              $deliveryAddressBtn.css("float", "right");

              /*LL Show user info + New order block START*/
              if (order.NAME) {
                $('#accept-order .client-info #client-name div:last-child').html(order.NAME).show();
              }
              if (order.MAIL) {
                $('#accept-order .client-info #client-email div:last-child').html(order.MAIL).show();
              }
              if (order.PHONE) {
                $('#accept-order .client-info #client-phone div:last-child').html(order.PHONE).show();
              }
              if (order.payment_type) {
                $('#accept-order .client-info #client-payment div:last-child').html(order.payment_type).show();
              }
              if (order.CHANGE) {
                $('#accept-order .client-info #client-change div:last-child').html(order.CHANGE).show();
              }
              if (order.NUMBER_OF_CUTLERY) {
                $('#accept-order .client-info #client-persons div:last-child').html(order.NUMBER_OF_CUTLERY).show();
              }
              if (order.ADDRESS.value) {
                $('#accept-order .client-info #client-address div:last-child').html(order.ADDRESS.value).show();
              }
              if (order.COMMENT) {
                $('#accept-order .client-info #client-comment div:last-child').html(order.COMMENT).show();
              }
              $('#accept-order').show();
              $('#multiorder-step').hide();
              /*LL Show user info + New order block END*/

              reinitMonthSlider();
              //startScrollbar();
              preOrderIDs = []; //LL Get order IDs
              $(window).scrollTop(0);
              $.each(data.data, function (index, value) {

                orderResult.data[index]['status'] = 'Ваш заказ №<i class="fa fa-spinner fa-pulse fa-2x fa-fw" style="font-size: 15px;"></i>';
                //showOrderStatus(index);
                getOrderNumber(value.orderId, index);
                preOrderIDs.push(value.orderId); //LL Get order IDs

                $.ajax({
                  url: '/ajax/getOrderCoupons.php?order_id=' + value.orderId,
                  type: 'post'
                }).done(function (res) {
                  if (res) {
                    $('.js-coupon').removeClass('hide');
                    $('.js-coupon-key').html(res);
                  }
                });
              });

              /*LL Update Order State + Get Alfa Payment and show START*/
              if (order.payment_id != 8) {
                //updateOrderState(preOrderIDs.join('_'));
              } else {
                /*$('#accept-order #main-icon-1').addClass('alfa_payment');
                $('#accept-order .status .text').text('Оплата и подтверждение');
                $('#accept-order .status .comment').text('После оплаты нельзя внести изменения в заказ.');
                $.ajax({
                  url: '/ajax/getPaymentAlfa.php?orderId=' + orderIDs.join('_'),
                  method: 'GET'
                }).done(function (data) {
                  var showPayment = false;

                  try {
                    JSON.parse(data);
                  } catch (e) {
                    showPayment = true;
                  }

                  if (showPayment) {
                    $('#order-alfa-payment').html(data);
                    $('#accept-order .order-but.disable').removeClass('disable');
                  } else {
                    console.log(data);
                  }
                });*/
              }
              /*LL Update Order State + Get Alfa Payment and show END*/
            }
          },
        });
      }
    });
  }

  /*LL Update Order State START*/
  function activation(n, nums, lines, imgList, taimer, button) {
    nums.each(function (i) {
      if (n - 1 >= i) {
        $(this).addClass('active marked');
      } else {
        $(this).removeClass('active marked');
      }

      if (n - 1 === i) {
        $(this).removeClass('marked');
      }

      if (n - 1 === 4) {
        $(this).addClass('active marked');
      }

      $(this).removeClass('cancel');
    })

    lines.each(function (i) {
      if (n - 1 > i) {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      }
    })

    imgList.each(function (i) {
      if (n - 1 === i) {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      }
    })

    if (n === 5) {
      taimer.addClass('disable');
      button.removeClass('disable');
    } else {
      taimer.removeClass('disable');
      button.addClass('disable');
    }
  }

  function changeOrderState(status, delivery, target) {
    let $title = $(document).find('#status-' + target + ' .status-cont .text');
    let $text = $(document).find('#status-' + target + ' .comment');

    let $nums = $(document).find('#status-' + target + ' .status-click');
    let $lines = $(document).find('#status-' + target + ' .lines');

    let $imgList = $(document).find('#status-' + target + ' .main-icon');

    let $taimer = $(document).find('#status-' + target + ' .time');
    let $button = $(document).find('#status-' + target + ' .button');

    switch (status) {
      case 'N':
        $title.text('Подтверждение');
        $text.html('С вами свяжется наш оператор<br>для подтверждения заказа');
        activation(1, $nums, $lines, $imgList, $taimer, $button);
        break;
      case 'IW':
        $title.text('Приготовление');
        $text.html('Ваш заказ уже начали готовить<br>наши повара');
        activation(2, $nums, $lines, $imgList, $taimer, $button);
        break;
      case 'AS':
        if (delivery == 3) {
          $title.text('Приготовлен');
          $text.html('Ваш заказ приготовлен<br>и готов к выдаче');
        } else {
          $title.text('Сборка');
          $text.html('Ваш заказ собирается<br>для передачи курьеру');
        }
        activation(3, $nums, $lines, $imgList, $taimer, $button);
        break;
      case 'DL':
        $title.text('Доставка');
        $text.html('Курьер уже едет с вашим заказом,<br>скоро вы вкусно покушаете');
        activation(4, $nums, $lines, $imgList, $taimer, $button);
        break;
      case 'F':
        if (delivery == 3) {
          $title.text('Вручен');
          $text.html('Ваш заказ выполнен');
        } else {
          $title.text('Доставлен');
          $text.html('Ждем Вас в другой раз');
        }
        activation(5, $nums, $lines, $imgList, $taimer, $button);
        break;
      case 'C':
        $title.text('Отменен');
        $text.html('Заказ отменен. Если вы не отменяли заказ, свяжитесь с нами по горячей линии, мы вам поможем.');
        $nums.each(function () {
          $(this).removeClass('active marked');
        });
        $lines.each(function () {
          $(this).removeClass('active');
        });
        $imgList.removeClass('active');
        $(document).find('#status-' + target + ' .status-cont .img .circle #cancel').addClass('active');
        $(document).find('#status-' + target + ' .status-cont .img .circle .n-2').addClass('active cancel');
        $taimer.addClass('disable');
        $button.addClass('disable');
        break;
      case 'DN':
        $title.text('Ожидание');
        $text.html('Проблема с заказом. Пожалуйста,<br>свяжитесь с оператором');
        $nums.each(function () {
          $(this).removeClass('active marked');
        });
        $lines.each(function () {
          $(this).removeClass('active');
        });
        $imgList.removeClass('active');
        $(document).find('#status-' + target + ' .status-cont .img .circle #expectation').addClass('active');
        $(document).find('#status-' + target + ' .status-cont .img .circle .n-2').addClass('active cancel');
        $taimer.addClass('disable');
        $button.addClass('disable');
        break;
    }
  }

  function updateOrderState(orderIDs) {
    setTimeout(function run() {
      $.ajax({
        url: '/ajax/getOrderState.php?orderId=' + orderIDs,
        method: 'GET'
      }).done(function (data) {
        let answer = JSON.parse(data);
        for (let i = 0; i < answer.length; i++) {
          if (answer[i].statusCode !== 'N') {
            changeOrderState(answer[i].statusCode, answer[i].deliverySystemId, answer[i].orderId);
          }
        }
      });
      setTimeout(run, 10000);
    }, 10000);
  }

  function updateOrderId(orderID, index) {
    if (index == 0) {
      $('#accept-order .top-part .number:not(mob) span').html(orderID);
      $('#accept-order .top-part .number.mob span').html('№' + orderID);
    }
    if ($('#accept-order .swither .date:eq(0)').attr('data-number') == 'all') {
      $('#accept-order .swither .date:eq(' + (index + 1) + ')').attr('data-number', orderID);
    } else {
      $('#accept-order .swither .date:eq(' + index + ')').attr('data-number', orderID);
    }
    $('#accept-order .left-part .status:eq(' + index + ')').attr('id', 'status-' + orderID);
  }

  function updateOrderIdNew(orderIDIIKO, orderID, index) {
    if (index === 0) {
      $(document).find('#accept-order .top-part .number:not(mob) span').html(orderIDIIKO);
      $(document).find('#accept-order .top-part .number.mob span').html('№' + orderIDIIKO);
    }
    if ($(document).find('#accept-order .swither .date:eq(0)').attr('data-number') === 'all') {
      $(document).find('#accept-order .swither .date:eq(' + (index + 1) + ')').attr('data-number', orderID);
    } else {
      $(document).find('#accept-order .swither .date:eq(' + index + ')').attr('data-number', orderID);
    }
    $(document).find('#accept-order .left-part .status:eq(' + index + ')').attr('id', 'status-' + orderID);
  }

  /*LL Update Order State END*/

  function getOrderNumber(orderID, index) {
    orderNumberInterval[orderID] = false;
    window.seconds = 0;
    window.MaxSeconds = 60;
    window.$orderNumber = null;
    $(function () {

      orderNumberInterval[orderID] = setInterval(function () {
        $.ajax({
          url: '/ajax/getAiikoNumber.php',
          method: 'POST',
          dataType: 'json',
          data: {
            account_number: orderID
          }
        }).done(function (data) {
          if (data.STATUS === 'SUCCESS') {
            orderResult.data[index]['status'] = 'Ваш заказ №' + data.NUMBER;
            //showOrderStatus(index);
            updateOrderIdNew(data.NUMBER, orderID, index); //LL Update Order ID
            clearInterval(orderNumberInterval[orderID]);
            updateOrderState(orderID);
            $.ajax({
                url: '/ajax/getOrderInfo.php?order_id=' + orderID,
                type: 'post'
            }).done(function (res) {
                res = JSON.parse(res);
                window.dataLayer = window.dataLayer || [];
                if (res && res.id) {
                  dataLayer.push({
                    'event': 'formsend',
                    'id': res.id,
                    'delivery': res.delivery,
                    'payment': res.payment,
                    'revenue': res.revenue
                  });
                } else {
                  dataLayer.push({
                    'event': 'formsend',
                    'id': orderID,
                    'delivery': '',
                    'payment': '',
                    'revenue': ''
                  });
                }
            });
          }
        });

        if (window.seconds > window.MaxSeconds) {
          orderResult.data[index]['status'] = 'Ваш заказ №' + orderID;
          //showOrderStatus(index);
          updateOrderId(orderID, index); //LL Update Order ID
          clearInterval(orderNumberInterval[orderID]);
          updateOrderState(orderID);
        }
        window.seconds++;
      }, 1000);
    });
  }

  function checkDelivery(flag = false) {
    if (selected && (!housetime || (new Date()).getTime() - housetime.getTime() > 5000)) {
      let s = $(document).find("#address").val().trim(),
        $house = $(document).find("#house"),
        $housing = $(document).find("#housing"),
        h = $house.val().trim(),
        housing = $housing.val().trim(),
        houseMatches;

      houseMatches = h.match(houseMask);

      if (!!houseMatches) {
        h = !!houseMatches[1] ? houseMatches[1].trim() : '';
        $house.val(h);

        if (!!houseMatches[2] && houseMatches[2] !== '') {
          housing = houseMatches[2].trim();
          $housing.val(housing);
        }
      }

      if (s) {
        if (h) {
          housetime = new Date();
          $(document).find('.form-group-help').text('');
          let v = s + ", д" + h;

          if (housing) {
            v += ", к" + housing;
          }

          if ($(document).find('.x-form-address-submit-btm').length) {
            if (flag) {
              checkDeliv(v);
              addres2(s + ", д" + h, false);
              typeAddress = 1;
            } else {
              $(document).find('.x-form-address-submit-btm').attr("disabled", false);
            }
          } else {
            checkDeliv(v);
            addres2(s + ", д" + h, false);
            typeAddress = 1;
          }
        } else {
          $(document).find('.form-group-help').text('Введите номер дома');
          if ($(document).find('.x-form-address-submit-btm').length) {
            $(document).find('.x-form-address-submit-btm').attr("disabled", true);
          }
        }
      }
    }
  }

  function checkDeliveryBtn() {
    if (selected && (!housetime || (new Date()).getTime() - housetime.getTime() > 5000)) {
      let s = $(document).find("#address").val().trim(),
        $house = $(document).find("#house"),
        $housing = $(document).find("#housing"),
        h = $house.val().trim(),
        housing = $housing.val().trim(),
        houseMatches;

      houseMatches = h.match(houseMask);

      if (!!houseMatches) {
        h = !!houseMatches[1] ? houseMatches[1].trim() : '';
        $house.val(h);

        if (!!houseMatches[2] && houseMatches[2] !== '') {
          housing = houseMatches[2].trim();
          $housing.val(housing);
        }
      }

      if (s) {
        if (h) {
          housetime = new Date();
          $(document).find('.form-group-help').text('');
          let v = s + ", д" + h;

          if (housing) {
            v += ", к" + housing;
          }

          checkDeliv(v);
          addres2(s + ", д" + h, false);
          typeAddress = 1;
        } else {
          $(document).find('.form-group-help').text('Введите номер дома');
          $(document).find('.x-form-address-submit-btm').attr("disabled", true);
        }
      }
    }
  }


  function checkDeliveryPopup() {
    if (selected && (!housetime || (new Date()).getTime() - housetime.getTime() > 5000)) {
      let s = $("#address_popup").val().trim(),
        $house = $("#house_popup"),
        $housing = $("#housing-popup"),
        h = $house.val().trim(),
        housing = $housing.val().trim(),
        houseMatches;

      houseMatches = h.match(houseMask);

      if (!!houseMatches) {
        h = !!houseMatches[1] ? houseMatches[1] : '';
        $house.val(h);

        if (!!houseMatches[2] && houseMatches[2] !== '') {
          housing = houseMatches[2].trim();
          $housing.val(housing);
        }
      }

      if (s) {
        if (h) {
          housetime = new Date();
          $('#address-popup .form-group-help').text('');
          let v = s + ", д" + h;

          if (housing) {
            v += ", к" + housing;
          }

          checkDelivPopup(v);
          addres2Popup(v, false);
          typeAddressPopup = 1;
        } else {
          $('#address-popup .form-group-help').text('Введите номер дома');
        }
      }
    }
  }

  //Показать блок с кнопками
  function showOrderButtons() {
    $('.wrapper > .order-button').hide();
    $('.form-order > .order-button').css('display', 'flex');
  }

  //Скрыть блок с кнопками
  function hideOrderButtons() {
    $('.order-button').hide();
    $('.wrapper').addClass('hidden-btns');
  }


  //Показать блок с кнопками
  function showOrderButtonsPopup() {
    $('.order-button-popup').show();
  }

  //Скрыть блок с кнопками
  function hideOrderButtonsPopup() {
    $('.order-button-popup').hide();
  }

  function showDeliveryInfoByTodayPriceCompany(price) {
    let $popupInfoBlock = $('.order-delivery-info-popup');

    $popupInfoBlock.addClass('map-alert-success');

    $popupInfoBlock.html(
      '<p>Сумма минимального заказа:</p>\n' +
      '<div class="min-sum">' + formatPrice(price) + '</div>'
    );
  }

  function showDeliveryInfoByTodayPrice(price) {
    let $popupInfoBlock = $('.order-delivery-info-popup');

    if (price > 0) {
      let todayMinPrice,
        tomorrowMinPrice,
        tomorrowMinPriceFormat;

      todayMinPrice = price > 1 ? formatPrice(price) : '<div class="text-gray">не возможна</div>';
      tomorrowMinPrice = parseInt(zoneList[price]);
      tomorrowMinPriceFormat = formatPrice(tomorrowMinPrice);

      $popupInfoBlock.addClass('map-alert-success');

      if (tomorrowMinPrice == 899) {
        $popupInfoBlock.html(
          '<p>Минимальный заказ при доставке на <span class="text-important">сегодня</span>:</p>\n' +
          '<div class="min-sum">' + todayMinPrice + '</div>' +
          '<p>Минимальный заказ на <span class="text-important">завтра и следующие дни</span>:</p>\n' +
          '<div class="min-sum"><span class="old-price">' + formatPrice(1200) + '</span> ' + tomorrowMinPriceFormat + '<sup>*</sup></div>' +
          '<div class="notion">* до 10.06.2020</div>'
        );
      } else {
        $popupInfoBlock.html(
          '<p>Минимальный заказ при доставке на <span class="text-important">сегодня</span>:</p>\n' +
          '<div class="min-sum">' + todayMinPrice + '</div>' +
          '<p>Минимальный заказ на <span class="text-important">завтра и следующие дни</span>:</p>\n' +
          '<div class="min-sum">' + tomorrowMinPriceFormat + '</div>'
        );
      }

    } else {
      $popupInfoBlock.addClass('map-alert-error');
      $popupInfoBlock.html('<p>К сожалению, для указанного адреса мы не можем доставить заказ.</p>');
    }
  }

  //Подстановка данных адреса
  function checkDeliv(address) {

    const $formGroupAddressMain = $('div.form-group-address-main');
    $formGroupAddressMain.removeClass('has-error');
    $formGroupAddressMain.removeClass('has-success');
    $formGroupAddressMain.find('div.form-group').removeClass('has-error');
    $formGroupAddressMain.find('div.form-group').removeClass('has-success');

    $('#loader1').show();
    $('.check-delivery-full').hide();

    saveAddress();
    $.ajax({
      url: '/ajax/checkDelivery.php',
      data: {
        url: 'http://hrm.hatimaki.ru/index.php',
        r: "maps/google/check-address-json",
        site_id: 2,
        address: address
      },
      success: function (data) {
        $('#loader1').hide();
        $('.check-delivery-full').show();
        let res = JSON.parse(data);

        if (res && res.terminal_id) {
          branchesDelivery = res.terminal_id;
        }

        // Если покупатель привязан к компании
        if (typeof companyOrderMinSum !== "undefined" && companyOrderMinSum) {
          // console.log('Привязан к компаниии (Подстановка данных адреса)');
          let deliveryError = false;

          for (let key in orderPriceList) {
            let orderPrice = parseFloat(orderPriceList[key].price);

            if (orderPrice < companyOrderMinSum) {
              deliveryError = true;
              break;
            }
          }

          if (deliveryError) {
            // console.log('Компания Ошибка доставки (Подстановка данных адреса)');
            $formGroupAddressMain.addClass('has-error');
            $formGroupAddressMain.find('div.form-group').addClass('has-error');

            $(".delivery-alert .alert-minprice").show();
            $(".delivery-alert .alert-notdelivery").hide();

            $(".delivery-alert [data-min-price]").text(companyOrderMinSum);

            $('.check-delivery').hide();
            $('.delivery-alert').show();
            $('div.info-txt').text('ТОЛЬКО САМОВЫВОЗ').addClass('info-txt-hide');
            hideOrderButtons();

            let a = $("#come_in_delivery_address").closest(".form-group").find(".dropdown-menu a");
            if (a.length == 1) {
              a.click();
            }

            showDeliveryInfoByTodayPriceCompany(companyOrderMinSum);
            $('#orderDeliveryPopup').modal({
              backdrop: 'static',
              keyboard: false
            });
          } else {
            // console.log('Компания все ок (Подстановка данных адреса)')
            $formGroupAddressMain.addClass('has-success');
            $formGroupAddressMain.find('div.form-group').addClass('has-success');

            $('.check-delivery').show();
            $('div.info-txt').text('ДОСТАВИМ ЗА 90 МИНУТ').addClass('info-txt-hide');
            $('.delivery-alert').hide();
            showOrderButtons();
            $('div#sum-delivery').html(formatPrice(companyOrderMinSum));
            $('.btn-to-step2').html('Далее');
          }

        }
        // Если покупатель не привязан к компании - проверка по зонам доставки
        else if (res && res.min_price > 0) {

          let todayMinOrderPrice = parseFloat(res.min_price) > 1 ? parseFloat(res.min_price) : false,
            tomorrowMinOrderPrice = parseFloat(zoneList[res.min_price]),
            deliveryError = false;

          for (let key in orderPriceList) {
            let orderPrice = parseFloat(orderPriceList[key].price);

            if (orderPriceList[key].today) {
              if (todayMinOrderPrice === false || orderPrice < todayMinOrderPrice) {
                deliveryError = true;
                break;
              }
            } else if (orderPrice < tomorrowMinOrderPrice) {
              deliveryError = true;
              break;
            }
          }

          if (deliveryError) {
            //  console.log('Ошибка доставки минимальная сумма (обычный юзер Подстановка данных адреса)')
            $formGroupAddressMain.addClass('has-error');
            $formGroupAddressMain.find('div.form-group').addClass('has-error');

            $(".delivery-alert .alert-minprice").show();
            $(".delivery-alert .alert-notdelivery").hide();

            if (todayMinOrderPrice) {
              $(".delivery-alert [data-min-price]").text(todayMinOrderPrice);
            } else {
              $(".delivery-alert [data-min-price]").text(tomorrowMinOrderPrice);
            }

            $('.check-delivery').hide();
            $('.delivery-alert').show();
            $('div.info-txt').text('ТОЛЬКО САМОВЫВОЗ').addClass('info-txt-hide');
            hideOrderButtons();

            let a = $("#come_in_delivery_address").closest(".form-group").find(".dropdown-menu a");
            if (a.length == 1) {
              a.click();
            }

            showDeliveryInfoByTodayPrice(parseFloat(res.min_price));
            $('#orderDeliveryPopup').modal({
              backdrop: 'static',
              keyboard: false
            });

          } else {
            $formGroupAddressMain.addClass('has-success');
            $formGroupAddressMain.find('div.form-group').addClass('has-success');

            $('.check-delivery').show();
            $('div.info-txt').text('ДОСТАВИМ ЗА 90 МИНУТ').addClass('info-txt-hide');
            $('.delivery-alert').hide();


            if ($('#delivery_button').parent().hasClass('active')) {
              showOrderButtons();
            }

            if (todayMinOrderPrice) {
              $('div#sum-delivery').html(formatPrice(todayMinOrderPrice));
            } else {
              $('div#sum-delivery').html(formatPrice(tomorrowMinOrderPrice));
            }

            window.updateStopList(null);
            $('.btn-to-step2').html('Далее');
          }

        } else {

          // console.log('Доставка не возможна')
          $formGroupAddressMain.addClass('has-error');
          $formGroupAddressMain.find('div.form-group').addClass('has-error');

          $(".delivery-alert .alert-minprice").hide();
          $(".delivery-alert .alert-notdelivery").show();
          $('.check-delivery').hide();
          $('.delivery-alert').show();
          $('div.info-txt').text('ТОЛЬКО САМОВЫВОЗ').addClass('info-txt-hide');
          $('.btn-to-step2').html('Заберу сам');
          hideOrderButtons();

          let a = $("#come_in_delivery_address").closest(".form-group").find(".dropdown-menu a");
          if (a.length == 1) {
            a.click();
          }

        }
        if (typeof companyOrderMinSum !== "undefined") {
          // Если запретить редактировать адрес
          if (typeof preventAddressChanges !== "undefined" && preventAddressChanges == 1) {
            $(document).find('.btn-to-step2').trigger('click');
          }
        }
      }
    });
  }

  function addres2(suggestion = {}, btn = true) {

    if (!window.customAddrFromPopup) {
      $('#flat').val('');
      $('#entry').val('');
      $('#floor').val('');
      //$('#housing').val('');
      $('#domofon').val('');
      $('#address_comment').val('');
    }
    $('#full_address').text(suggestion);
    $('div[id=address-befor-check]').hide();
    $('div[class=form-group-address-check]').show();
    $('#map2').show;
    init_map($('#full_address').text(), 'map');
    if (btn) {
      showOrderButtons();
    }
  }

  function checkDelivPopup(address) {
    $('#address-popup div.form-group-address-main').removeClass('has-error');
    $('#address-popup div.form-group-address-main').removeClass('has-success');
    $('#address-popup div.form-group-address-main').find('div.form-group').removeClass('has-error');
    $('#address-popup div.form-group-address-main').find('div.form-group').removeClass('has-success');
    $('#address-popup #loader1').show();
    $('#address-popup .check-delivery-full').hide();

    $.ajax({
      url: '/ajax/checkDelivery.php',
      data: {
        url: 'http://hrm.hatimaki.ru/index.php',
        r: "maps/google/check-address-json",
        site_id: 2,
        address: address
      },
      success: function (data) {
        $('#address-popup #loader1').hide();
        $('#address-popup .check-delivery-full').show();
        let res = JSON.parse(data);
        if (res && res.terminal_id) {
          branchesDelivery = res.terminal_id;
        }

        // Если покупатель привязан к компании
        if (typeof companyOrderMinSum !== "undefined" && companyOrderMinSum) {
          let deliveryError = false;

          for (let key in orderPriceList) {
            let orderPrice = parseFloat(orderPriceList[key].price);

            if (orderPrice < companyOrderMinSum) {
              deliveryError = true;
              break;
            }
          }

          if (deliveryError) {
            console.log('company? delivery error!');
            $('#address-popup div.form-group-address-main').addClass('has-error');

            $('#address-popup div.form-group-address-main').find('div.form-group').addClass('has-error');
            $("#address-popup .delivery-alert .alert-minprice").show();
            $("#address-popup .delivery-alert .alert-notdelivery").hide();

            $("#address-popup .delivery-alert [data-min-price]").text(companyOrderMinSum);

            $('#address-popup .check-delivery').hide();
            $('#address-popup .delivery-alert').show();
            $('#address-popup div.info-txt').text('ТОЛЬКО САМОВЫВОЗ');
            hideOrderButtonsPopup();

            let a = $("#address-popup #come_in_delivery_address").closest(".form-group").find(".dropdown-menu a");
            if (a.length == 1) {
              a.click();
            }

            showDeliveryInfoByTodayPriceCompany(parseFloat(companyOrderMinSum));
            $('#orderDeliveryPopup').modal({
              backdrop: 'static',
              keyboard: false
            });

          } else {
            console.log('company? delivery ok!');
            $('#address-popup div.form-group-address-main').addClass('has-success');
            $('#address-popup div.form-group-address-main').find('div.form-group').addClass('has-success');
            $('#address-popup .check-delivery').show();
            $('#address-popup div.info-txt').text('ДОСТАВИМ ЗА 90 МИНУТ');
            $('#address-popup .delivery-alert').hide();

            showOrderButtonsPopup();

            $('#address-popup div#sum-delivery').html(formatPrice(companyOrderMinSum));
          }
        }
        // Если покупатель не привязан к компании - проверка по зонам доставки
        else if (res && res.min_price > 0) {
          console.log('no company? check delivery!');

          let todayMinOrderPrice = parseFloat(res.min_price) > 1 ? parseFloat(res.min_price) : false,
            tomorrowMinOrderPrice = parseFloat(zoneList[res.min_price]),
            deliveryError = false;

          for (let key in orderPriceList) {
            let orderPrice = parseFloat(orderPriceList[key].price);

            if (orderPriceList[key].today) {
              if (todayMinOrderPrice === false || orderPrice < todayMinOrderPrice) {
                deliveryError = true;
                break;
              }
            } else if (orderPrice < tomorrowMinOrderPrice) {
              deliveryError = true;
              break;
            }
          }

          if (deliveryError) {
            console.log('no comp? delivery error!');
            $('#address-popup div.form-group-address-main').addClass('has-error');

            $('#address-popup div.form-group-address-main').find('div.form-group').addClass('has-error');
            $("#address-popup .delivery-alert .alert-minprice").show();
            $("#address-popup .delivery-alert .alert-notdelivery").hide();

            if (todayMinOrderPrice) {
              $("#address-popup .delivery-alert [data-min-price]").text(todayMinOrderPrice);
            } else {
              $("#address-popup .delivery-alert [data-min-price]").text(tomorrowMinOrderPrice);
            }


            $('#address-popup .check-delivery').hide();
            $('#address-popup .delivery-alert').show();
            $('#address-popup div.info-txt').text('ТОЛЬКО САМОВЫВОЗ');
            hideOrderButtonsPopup();

            let a = $("#address-popup #come_in_delivery_address").closest(".form-group").find(".dropdown-menu a");
            if (a.length == 1) {
              a.click();
            }

            showDeliveryInfoByTodayPrice(parseFloat(res.min_price));
            $('#orderDeliveryPopup').modal({
              backdrop: 'static',
              keyboard: false
            });
          } else {
            console.log('no comp? delivery success!');
            $('#address-popup div.form-group-address-main').addClass('has-success');
            $('#address-popup div.form-group-address-main').find('div.form-group').addClass('has-success');
            $('#address-popup .check-delivery').show();
            $('#address-popup div.info-txt').text('ДОСТАВИМ ЗА 90 МИНУТ');
            $('#address-popup .delivery-alert').hide();
            showOrderButtonsPopup();
            if (todayMinOrderPrice) {
              $('#address-popup div#sum-delivery').html(formatPrice(todayMinOrderPrice));
            } else {
              $('#address-popup div#sum-delivery').html(formatPrice(tomorrowMinOrderPrice));
            }
          }

        } else {

          $('#address-popup div.form-group-address-main').addClass('has-error');

          $('#address-popup div.form-group-address-main').find('div.form-group').addClass('has-error');
          $("#address-popup .delivery-alert .alert-minprice").hide();
          $("#address-popup .delivery-alert .alert-notdelivery").show();
          $('#address-popup .check-delivery').hide();
          $('#address-popup .delivery-alert').show();
          $('#address-popup div.info-txt').text('ТОЛЬКО САМОВЫВОЗ');
          hideOrderButtonsPopup();

          var a = $("#address-popup #come_in_delivery_address").closest(".form-group").find(".dropdown-menu a");
          if (a.length == 1) {
            a.click();
          }
        }
        saveAddress();
      }
    });
  }

  function addres2Popup(suggestion = {}, btn = true) {
    $('#full_address_popup').text(suggestion);
    $('#address-popup #entry').val('');
    $('#address-popup #floor').val('');
    // $('#address-popup #housing').val('');
    $('#address-popup #domofon').val('');
    $('#address-popup #flat').val('');
    $('#address-popup #address_comment').val('');
    $('#address-popup div[id=address-befor-check]').hide();
    $('#address-popup div[class=form-group-address-check]').show();
    $('#address-popup #map2').show;
    init_map($('#full_address_popup').text(), 'map_popup');
    if (btn) {
      showOrderButtonsPopup();
    }
  }

  //Ссылка в карзину
  function to_basket() {
    document.location.href = '/personal/cart/';
  }

  window.to_basket = to_basket;

  /*  function startScrollbar() {
      let $block = $(".rid__main");
      if (window.screen.width > 640) {
        $block.mCustomScrollbar("destroy");
      } else {
        $block.mCustomScrollbar("destroy");
        $block.mCustomScrollbar({
          mouseWheel: {enable: true, preventDefault: false}
        });
      }
    }*/

//Адрес в объект
  window.to_step_2 = function () {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'checkout_step2',
      'delivery': typeAddress == 1 ? 'courier' : 'samovyvoz'
    });

    reloadBasket();

    //startScrollbar();

    switch (typeAddress) {
      case 1:
        order = {
          ADDRESS: {
            delivery_id: 2,
            street: $(document).find('#address').val(),
            value: $(document).find('#full_address').text(),
            flat: $(document).find('input[name=flat]').val(),
            housing: $(document).find('input[name=housing]').val(),
            house: $(document).find('input[name=house]').val(),
            entry: $(document).find('input[name=entry]').val(),
            floor: $(document).find('input[name=floor]').val(),
            domofon: $(document).find('input[name=domofon]').val(),
            address_comment: $(document).find('textarea[name=address_comment]').val()
          }
        };

        break;
      case 3:
        order = {
          ADDRESS: {
            value: $(document).find('#come_in_delivery_address').find('.address').text(),
            delivery_id: 3,
            terminal_guid: $(document).find('#come_in_delivery_address').find('.address').data('guid'),
          }
        };
        break;
      case 2:
        order = {
          ADDRESS: {
            value: $(document).find('#come_address').find('.address').text(),
            delivery_id: 3,
            terminal_guid: $(document).find('#come_address').find('.address').data('guid'),
          }
        };
        break;
    }

    if (typeof order['ADDRESS'] !== "undefined") {
      let isOneDayOrder = $(document).find("form.form-order").data('isoneday');
      /**
       * Убираем лишние шаги, если заказ не на один день.
       */
      fillOrdersDeliveryInfo();
      $(document).find('.order_info').hide();
      if (!isOneDayOrder) {
        markStep(2);
        $(document).find('.order-button').hide();
        $(document).find('[data-step]').hide();
        $(document).find('[data-step="2"]').show();
        $(document).find('.send_order').hide();
        reinitMonthSlider();
      } else {
        to_step_3();
      }

    }

    let validator = $(document).find("form.form-order").validate();

    if ($(document).find("form.form-order input[name=name]").val()) {
      validator.element("form.form-order input[name=name]");
    }

    // if ($(document).find("form.form-order input[name=email]").val()) {
    //   validator.element("form.form-order input[name=email]");
    // }

    if ($(document).find("form.form-order input[name=phone]").val()) {
      validator.element("form.form-order input[name=phone]");
    }
  }

  //возвращение к
  window.to_step_1 = function () {
    reloadBasket();
    markStep(1);
    reloadBasket();
    // $('.order-button').hide();
    $(document).find(".btn-next").hide();
    $(document).find('.order_info').show();
    $(document).find('.send_order').hide();
    $(document).find('#step_1').show();
    $(document).find('#step_2').hide();
    $(document).find('#step_3').hide();
    $(document).find('#map2').hide();
    $(document).find('#map').hide();
    housetime = false;
    if (typeAddress !== 2) {
      checkDelivery();
    } else {
      showOrderButtons();
    }
  }

  $(document).find('.js-orders-off').on('click', function () {
    $('#ordersOffModal').foundation('open');
  });

  $(document).find('#delivery_button').on('click', function () {
    housetime = false;
    checkDelivery(true);
  });

  $(document).find('.x-form-address-submit-btm').on('click', function () {
    housetime = false;
    checkDeliveryBtn();
  });

  window.setOrderDeliveryByOrderId = function (el) {
    let selectedOrder = {},
      orderId = $(el).data('order');

    switch (typeAddressPopup) {
      case 1:
        selectedOrder = {
          ADDRESS: {
            delivery_id: 2,
            value: $(document).find('#full_address_popup').text(),
            street: $(document).find('#address_popup').val(),
            house: $(document).find('#address-popup input[name=house]').val(),
            housing: $(document).find('#address-popup input[name=housing]').val(),
            flat: $(document).find('#address-popup input[name=flat]').val(),
            entry: $(document).find('#address-popup input[name=entry]').val(),
            floor: $(document).find('#address-popup input[name=floor]').val(),
            domofon: $(document).find('#address-popup input[name=domofon]').val(),
            address_comment: $(document).find('#address-popup textarea[name=address_comment]').val()
          }
        };

        $(document).find('#address').val(selectedOrder.ADDRESS.street);
        $(document).find('#full_address').text(selectedOrder.ADDRESS.value);
        $(document).find('input[name=flat]').val(selectedOrder.ADDRESS.flat);
        $(document).find('input[name=housing]').val(selectedOrder.ADDRESS.housing);
        $(document).find('input[name=house]').val(selectedOrder.ADDRESS.house);
        $(document).find('input[name=entry]').val(selectedOrder.ADDRESS.entry);
        $(document).find('input[name=floor]').val(selectedOrder.ADDRESS.floor);
        $(document).find('input[name=domofon]').val(selectedOrder.ADDRESS.domofon);
        $(document).find('textarea[name=address_comment]').val(selectedOrder.ADDRESS.address_comment);

        break;
      case 3:
        selectedOrder = {
          ADDRESS: {
            value: $(document).find('#come_in_delivery_address_popup').find('.address').text(),
            delivery_id: 3,
            terminal_guid: $(document).find('#come_in_delivery_address_popup').find('.address').data('guid'),
          }
        };
        $(document).find('#come_in_delivery_address').find('.address').text(selectedOrder.ADDRESS.value);
        $(document).find('#come_in_delivery_address').find('.address').data('guid', selectedOrder.ADDRESS.terminal_guid);
        break;
      case 2:
        selectedOrder = {
          ADDRESS: {
            value: $(document).find('#come_address_popup').find('.address').text(),
            delivery_id: 3,
            terminal_guid: $(document).find('#come_address_popup').find('.address').data('guid'),
          }
        };

        $(document).find('#come_address').find('.address').text(selectedOrder.ADDRESS.value);
        $(document).find('#come_address').find('.address').data('guid', selectedOrder.ADDRESS.terminal_guid);
        break;
    }

    if (typeof selectedOrder.ADDRESS !== "undefined") {
      $.each(orderDateList, function (index, value) {
        if (value == orderId) {
          order.orderDeliveriesInfo[value] = JSON.parse(JSON.stringify(selectedOrder.ADDRESS));
          order.orderDeliveriesInfo[value]['deliveryTime'] = $(document).find('.js-order-delivery-time[data-order="' + value + '"]').val();
          $(document).find('.js-order-delivery-address-btn[data-order="' + value + '"]').find('.js-order-delivery-address-text').html(selectedOrder.ADDRESS.value);
          $(document).find('.js-basket-day-container[data-addr-order="' + value + '"]').find("[data-entity='js-order-delivery-type-address']").html(selectedOrder.ADDRESS.delivery_id === 3 ? 'Адрес самовывоза:' : 'Адрес доставки:');
          $(document).find('.js-basket-day-container[data-addr-order="' + value + '"]').find("[data-entity='js-order-delivery-type-time']").html(selectedOrder.ADDRESS.delivery_id === 3 ? 'Время самовывоза' : 'Время доставки');

          $(document).find('.js-basket-day-container[data-addr-order="' + value + '"]').attr('data-delivery-id', selectedOrder.ADDRESS.delivery_id);
        }
      });
    }
  }

  function reinitMonthSlider() {
    let $slider = $(".month");
    $slider.slick('reinit');
  }

  function setOrderDeliveryTimeInfo(orderId, deliveryTime) {
    order.orderDeliveriesInfo[orderId]['deliveryTime'] = deliveryTime;
  }

  function fillOrdersDeliveryInfo() {

    $('.js-order-delivery-address-text').html(order.ADDRESS.value);
    $("[data-entity='js-order-delivery-type-address']").html(order.ADDRESS.delivery_id === 3 ? 'Адрес самовывоза:' : 'Адрес доставки:');
    $("[data-entity='js-order-delivery-type-address']").data('delivery-type', order.ADDRESS.delivery_id);
    $("[data-entity='js-order-delivery-type-time']").html(order.ADDRESS.delivery_id === 3 ? 'Время самовывоза' : 'Время доставки:');

    $(document).find('.js-basket-day-container[data-addr-order="0"]').attr('data-delivery-id', order.ADDRESS.delivery_id);

    order.orderDeliveriesInfo = [];

    $.each(orderDateList, function (index, value) {
      order.orderDeliveriesInfo[value] = JSON.parse(JSON.stringify(order.ADDRESS));
      order.orderDeliveriesInfo[value]['deliveryTime'] = $('.js-order-delivery-time[data-order="' + value + '"]').val();

    });
  }

  //возвращение к
  window.to_step_3 = function () {
    reloadBasket();
    let terminal = '';
    if (typeof order['ADDRESS'] !== "undefined") {
      markStep(3);
      $('[data-step]').hide();
      $('[data-step="3"]').show();

      $(".step2-personal-data").show();

      $('.order-button').show();

      if (window.innerWidth <= 757) {
        $('.btn-next').show();
        $(".step2-payment").hide();
        $(".panel-order .order-sum").hide();
      } else {
        $('.send_order').show();
      }

      var flagHideOnlinePay = 0,
          checkTerminal = branchesDelivery;

      if (typeof order.orderDeliveriesInfo !== "undefined") {
        if (typeof branchesHideOnlinePay !== "undefined") {
          $.each(order.orderDeliveriesInfo, function (index, value) {
            if (typeof value.terminal_guid !== "undefined") {
              checkTerminal = value.terminal_guid;
            }
            if (branchesHideOnlinePay[checkTerminal] == "Y") {
              flagHideOnlinePay = flagHideOnlinePay + 1;
            }
          })
        }
      }

      if (flagHideOnlinePay > 0) {
        $(document).find('.x-dropdown-menu-payment').find('.x-payment-li-8').addClass('hide');
      } else {
        $(document).find('.x-dropdown-menu-payment').find('.x-payment-li-8').removeClass('hide');
      }
    }

    if ($(document).find('.js-basket-day-container[data-addr-order="0"]').attr('data-delivery-id') == 3) {
      $(document).find('#dPayment').parent().find('[pay_id=6]').html('Оплата картой');
    } else {
      $(document).find('#dPayment').parent().find('[pay_id=6]').html('Картой курьеру');
    }
  };

  window.to_step_final = function () {
    let pay_id = $('#payment_type span').attr('pay_id');
    let payment = 'cash';
    if (pay_id == 8 || pay_id == 9) {
      payment = 'card_online';
    } else if (pay_id == 6) {
      payment = 'card_courier';
    }
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'checkout_step3',
      'payment': payment
    });
  };

  window.chenge_addres = function () {
    $('#come_in_delivery_address').text('');
    $('div[id=address-befor-check]').show();
    $('div[class=form-group-address-check]').hide();
    $('#map2').hide();
    $('#map').hide();
    hideOrderButtons();
    $('#full_address').html('');
  }

  window.chenge_addresPopup = function () {
    $('#address-popup #come_in_delivery_address').text('');
    $('#address-popup div[id=address-befor-check]').show();
    $('#address-popup div[class=form-group-address-check]').hide();
    $('#map2_popup').hide();
    $('#map_popup').hide();
    hideOrderButtonsPopup();
    $('#address-popup #full_address').html('');
  }

  /** Дубликаторы клика по полю */
  $('[data-action="change-address"]').on('click', () => {
    chenge_addres();
    $(document).find('#address').focus();
  });

  function doTimer() {
    var start_datetime = new Date();
    var diff = end_datetime.getTime() - start_datetime.getTime();
    var orderCheck = $('#order-check');

    if (diff <= 0 || isNaN(diff)) {
      orderCheck.find('.sms-repeat').html("<a href='javascript:void(0)'>Выслать код повторно</a>").removeAttr('disabled');
      window.clearInterval(smsAgain);
    } else {
      var seconds = Math.floor(diff / 1000);
      var minutes = Math.floor(seconds / 60);
      seconds -= minutes * 60;

      minutes += "";
      if (minutes.length == 1) {
        minutes = "0" + minutes;
      }
      seconds += "";
      if (seconds.length == 1) {
        seconds = "0" + seconds;
      }
      $time.html(minutes + ":" + seconds);
    }
  }

  function sendSmsAgain() {
    var orderCheck = $('#order-check');

    orderCheck.find('.sms-repeat')
      .attr('disabled', 'disabled')
      .html('Выслать код повторно через <span></span>')
    ;

    var $time = orderCheck.find('.sms-repeat span');
    if ($time.length == 0) {
      return;
    }

    var time = new Date();
    time.setMinutes(time.getMinutes() + 5);
    var end_datetime = new Date(time);

    smsAgain = window.setInterval(doTimer, 1000);
    doTimer();
  }

  $(function () {

    $(document).on('input', '#address', function () {
      selected = false;
    });

    $(document).find("#address").blur(function () {
      let t = this;
      setTimeout(function () {
        if (!selected) {
          $(document).find("#address").val('');
        }
      }, 200)
    });

    $(document).find('#address').keypress(function (e) {
      if (e.keyCode == 13) {
        $(document).find('#address').trigger("blur");
      }
    });

    $(document).find('#house').keypress(function (e) {
      if (e.keyCode == 13) {
        housetime = false;
        checkDelivery();
      }
    });

    $(document).find('#house').blur(function (e) {
      housetime = false;
      checkDelivery();
    });

    $(document).on('input', '#house', function (e) {
      housetime = new Date();
      setTimeout(function () {
        checkDelivery();
      }, 5000)
    });

    $(document).find('#house_popup').keypress(function (e) {
      if (e.keyCode == 13) {
        housetime = false;
        checkDeliveryPopup();
      }
    });

    $(document).find('#house_popup').blur(function (e) {
      housetime = false;
      checkDeliveryPopup();
    });

    $(document).on('input', '#house_popup', function (e) {
      housetime = new Date();
      setTimeout(function () {
        checkDeliveryPopup();
      }, 5000)
    });

    $(document).find("#address").autocomplete({
      source: "/ajax/autocompleteAddress2.php",
      minLength: 1,
      appendTo: '#address-container',
      focus: function (event, ui) {
        selected = false;
      },
      select: function (event, ui) {
        if (ui.item.value.length) {
          $(document).find("#address").val(ui.item.value);
          $(document).find("#address").attr('value', ui.item.value);
        }
        selected = true;
        setTimeout(function () {
          checkDelivery();
        }, 50)
      },
      close: function (event, ui) {
        /*var $autocompleteItems = $('.ui-autocomplete > li'),
          length = $autocompleteItems.length;

        if (length === 1) {
          $("#address").val($autocompleteItems.find('.ui-menu-item-wrapper').html());
          selected = true;

          setTimeout(function () {
            checkDelivery();
          }, 50)
        }*/
      }
    });

    $("#address_popup").autocomplete({
      source: "/ajax/autocompleteAddress2.php",
      minLength: 1,
      appendTo: '#address-container_popup',
      focus: function (event, ui) {
        selected = false;
      },
      select: function (event, ui) {
        if (ui.item.value.length) {
          $(document).find("#address").val(ui.item.value);
        }
        selected = true;
        setTimeout(function () {
          checkDeliveryPopup();
        }, 50)
      }
    });


    $(window).on("load resize", function () {
      // если кнопки не скрыты, то показываем нужный блок с кнопками
      if (!$('.wrapper').hasClass('hidden-btns')) {
        showOrderButtons();
      }
    });


    initNavbar();
    hideOrderButtons();
    hideOrderButtonsPopup();
    checkPopUpAddress();


    function checkPopUpAddress() {
      let orderForm = $('.form-respons.form-order');
      if (orderForm.data('addr-popup') == 1) {
        window.customAddrFromPopup = true;
        housetime = false;
        selected = true;
        setTimeout(function () {
          checkDelivery(true);
        }, 1300);
      }
    }


    //Выбор из списка самовывоза
    $("#come_address").bind("DOMSubtreeModified", function () {

      typeAddress = 2;
      var address = $("#come_address").find('span.address').text();
      if (address !== '') {
        $('.form-label_primary').addClass('hide');
        init_map(address, 'map2');
        $('#map2').show;
      } else {
        $('.form-label_primary').removeClass('hide');
      }
      $.ajax({
        url: '/ajax/checkDelivery.php',
        data: {
          url: 'http://hrm.hatimaki.ru/index.php',
          r: "maps/google/check-address-json",
          address: 'москва' + address,
          site_id: "2",
        },
        success: function (data) {
          var res = JSON.parse(data);
          if (res && res.terminal_id) {
            branchesDelivery = res.terminal_id;
          }
          if (res && res.min_price > 0) {
            sum_delivery = res.min_price;
          }
        }
      });
      if ($("#come_address").find('span.address').data('guid')) {
        window.updateStopList($("#come_address").find('span.address').data('guid'));
      } else {
        // console.log('no guid!');
      }

      showOrderButtons();
    });

    //Выбор из списка самовывоза
    $("#come_address_popup").bind("DOMSubtreeModified", function () {
      typeAddressPopup = 2;
      var address = $("#come_address_popup").find('span.address').text();
      if (address !== '') {
        $('.form-label_popup').addClass('hide');
        init_map(address, 'map2_popup');
        $('#map2_popup').show;
      } else {
        $('.form-label_popup').removeClass('hide');
      }
      $.ajax({
        url: '/ajax/checkDelivery.php',
        data: {
          url: 'http://hrm.hatimaki.ru/index.php',
          r: "maps/google/check-address-json",
          address: 'москва' + address,
          site_id: "2",
        },
        success: function (data) {
          var res = JSON.parse(data);
          if (res && res.terminal_id) {
            branchesDelivery = res.terminal_id;
          }
          if (res && res.min_price > 0) {
            sum_delivery = res.min_price;
          }
        }
      });
      //console.log('//1!! Выбор из списка самовывоза');
      window.updateStopList($("#come_address_popup").find('span.address').data('guid'));
      showOrderButtonsPopup();
    });

    $("#come_in_delivery_address").bind("DOMSubtreeModified", function () {
      init_map($("#come_in_delivery_address").find('span.address').text(), 'map');
      showOrderButtons();
      // console.log('come_in_delivery_address DOMSubtreeModified');
      //  window.updateStopList($("#come_in_delivery_address").find('span.address').data('guid'));
      typeAddress = 3;
    });

    $("#come_in_delivery_address_popup").bind("DOMSubtreeModified", function () {
      init_map($("#come_in_delivery_address_popup").find('span.address').text(), 'map_popup');
      showOrderButtonsPopup();
      typeAddressPopup = 3;
    });

    //Выбор из списка моих адресов
    $("#my_addresses").bind("DOMSubtreeModified", function () {
      $('#my_addresses ').find('span.address').each(function (index) {
        $('#full_address').text($(this).attr('data-value'));
        $('input[name=flat]').val($(this).attr('data-flat'));
        $('input[name=domofon]').val($(this).attr('data-domofon'));
        $('textarea[name=address_comment]').val($(this).attr('data-address_comment'));
        $('input[name=entry]').val($(this).attr('data-entry'));
        $('input[name=floor]').val($(this).attr('data-floor'));
        $('input[name=housing]').val($(this).attr('data-housing'));
        $('input[name=house]').val($(this).attr('data-house'));
        $('input[name=address]').val($(this).attr('data-street'));
        $('input[name=house]').val($(this).attr('data-house'));
        $('input[name=address]').val($(this).attr('data-street'));

      });
      if ($('#full_address').text() !== '') {
        checkDeliv($('#full_address').text());
        typeAddress = 1;
        $('div[id=address-befor-check]').hide();
        init_map($('#full_address').text(), 'map');
        $('div[class=form-group-address-check]').show();
      }
    });

    //Выбор из списка моих адресов
    $("#my_addresses_popup").bind("DOMSubtreeModified", function () {
      $('#my_addresses_popup').find('span.address').each(function (index) {
        $('#full_address_popup').text($(this).attr('data-value'));
        $('#address-popup input[name=flat]').val($(this).attr('data-flat'));
        $('#address-popup input[name=domofon]').val($(this).attr('data-domofon'));
        $('#address-popup textarea[name=address_comment]').val($(this).attr('data-address_comment'));
        $('#address-popup input[name=entry]').val($(this).attr('data-entry'));
        $('#address-popup input[name=floor]').val($(this).attr('data-floor'));
        $('#address-popup input[name=housing]').val($(this).attr('data-housing'));
      });
      if ($('#full_address_popup').text() !== '') {
        checkDelivPopup($('#full_address_popup').text());
        typeAddressPopup = 1;
        $('#address-popup div[id=address-befor-check]').hide();
        init_map($('#full_address_popup').text(), 'map_popup');
        $('#address-popup div[class=form-group-address-check]').show();
      }
    });

    $("#come_button").click(function () {

      $('#come_in_delivery_address').text('');
      hideOrderButtons();
      $('#come').show();
      $('#come').prop('class', 'active');

      $('#delivery').hide();
      $('#delivery').removeAttr('class');
      $('#come_address').text('');

      var a = $("#come_address").closest(".form-group").find(".dropdown-menu a");
      if (a.length == 1) {
        a.click();
      }
    });

    $("#come_button_popup").click(function () {
      $('#address-popup #come_in_delivery_address').text('');
      hideOrderButtonsPopup();
      $('#address-popup #come').show();
      $('#address-popup #come').prop('class', 'active');

      $('#address-popup #delivery').hide();
      $('#address-popup #delivery').removeAttr('class');
      $('#come_address_popup').text('');

      var a = $("#come_address_popup").closest(".form-group").find(".dropdown-menu a");
      if (a.length == 1) {
        a.click();
      }
    });

    $("#delivery_button").click(function () {
      $('#delivery').show();
      $('#delivery').prop('class', 'active');
      $('#come').hide();
      $('#come').removeAttr('class');

      if ($('.delivery-alert').is(':visible')) {
        var a = $("#come_in_delivery_address").closest(".form-group").find(".dropdown-menu a");
        if (a.length == 1) {
          a.click();
        }
      } else {
        if (!$('#full_address').is(':empty')) {
          init_map($('#full_address').text(), 'map');
        } else {
          hideOrderButtons();
        }
      }
    });

    $("#delivery_button_popup").click(function () {
      $('#address-popup #delivery').show();
      $('#address-popup #delivery').prop('class', 'active');
      $('#address-popup #come').hide();
      $('#address-popup #come').removeAttr('class');

      if ($('#address-popup .delivery-alert').is(':visible')) {
        var a = $("#address-popup #come_in_delivery_address").closest(".form-group").find(".dropdown-menu a");
        if (a.length == 1) {
          a.click();
        }
      } else {
        if (!$('#full_address_popup').is(':empty')) {
          init_map($('#full_address_popup').text(), 'map_popup');
        } else {
          hideOrderButtonsPopup();
        }
      }
    });


    $('form.form-order').submit(false);
    $('form.form-order').on('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).validate();
    });

    //Валидация
    $("form.form-order").validate({
      ignore: [],
      rules: {
        name: {
          required: true,
          minlength: 2
        },
        phone: {
          required: true,
          myPhone: true,
        },
        email: {
          email: true,
        }
      },
      messages: {
        name: {
          required: "Укажите ваше имя",
          minlength: 'Укажите ваше имя',
        },
        phone: {
          required: "Укажите ваш номер телефона",
          myPhone: 'Введите корректный телефон',
        },
        email: {
          required: "Укажите ваш e-mail",
          email: "Введите корректный e-mail",
        }
      },
      highlight: function (element) {

        $(element).closest('.form-group').addClass('has-error');
        setTimeout(function () {
          var textError = $(element).closest('.form-group').find('.error').text();
          $(element).closest('.form-group').find('.error-message').text(textError);
        }, 100);

      },
      unhighlight: function (element) {
        $(element).closest('.form-group').removeClass('has-error');
        $(element).closest('.form-group').addClass('has-success');
      },
      errorElement: 'div',
      submitHandler: function (form, e) {
        e.preventDefault();
        e.stopPropagation();
        let smsModal = $("#sms-confirm-reveal");
        if (smsModal.length && $('#phone').val()) {
          try {
            if (!window.authPass instanceof AuthPass) {
              window.authPass = new AuthPass();
            }
            /**
             * @type window.authPass {AuthPass}
             */
            if (!window.authPass.checkAutoAuthBinded()) {
              window.authPass.autoAuth($(form).find('.js-phone').val());
              window.authPass.bindFaultAction(function (sendForm) {
                $('#CONFIRMED').val('Y');
                sendForm();
              }.bind(this, sendForm));
              window.authPass.bindAutoAuth(function (smsModal) {
                smsModal.foundation();
                smsModal.foundation('open');
              }.bind(this, smsModal));

              window.authPass.bindFinalAction(function (smsModal, sendForm) {
                smsModal.foundation('close');
                $('#CONFIRMED').val('Y');
                sendForm();
              }.bind(this, smsModal, sendForm));
            } else {
              window.authPass.autoAuth($(form).find('.js-phone').val());
              smsModal.foundation();
              smsModal.foundation('open');
            }
          } catch (e) {
            $('#CONFIRMED').val('Y');
            sendForm();
          }
        } else {
          $('#CONFIRMED').val('Y');
          sendForm();
        }

      }
    });


    /*
    $(window).on("load resize", function () {
      var winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (winWidth >= 900) {
        $(".content-page-scroll .content").mCustomScrollbar({
          axis: "y",
          theme: "light-3"
        });
      } else {
        $('.content-page-scroll .content').mCustomScrollbar("destroy");
      }
    });
     */


    $('.step1').click(function () {
      to_step_1();
      $(".btn-next").hide();
      $(".send_order").hide();
      $(".panel-order .order-sum").hide();
    });

    $('.step3').click(function () {
      $(".send_order").hide();
      if ($("#order-steps > li:first-child").hasClass("active"))
        $(".btn-next").hide();
      to_step_3();
      $(".panel-order .order-sum").hide();
    });

    // скрывать поле Сдача при выборе оплаты Картой курьеру
    $('#dPayment').parent().on('hidden.bs.dropdown', function () {
      var pay_id = $(this).find('#payment_type span').attr('pay_id'),
        COURIER_CARD_ID = '6',
        ALFA_PAYMENT_ID = '8',
        dChange = $(this).closest('.step2-payment').find('#dChange').parent(),
        echeque = $(this).closest('.step2-payment').find('#echeque').parent(),
        echequeInput = $('#echeque'),
        email = $('#email');
      if (pay_id == COURIER_CARD_ID || pay_id == ALFA_PAYMENT_ID) {
        dChange.hide();
      } else {
        dChange.show();
      }
      if (pay_id == ALFA_PAYMENT_ID) {
        echeque.show();
        echequeInput.prop("checked", true)
        email.rules("add", {required: true});
        email.valid();
      } else {
        echeque.hide();
        echequeInput.prop("checked", false)
        email.rules("remove", "required");
        email.parent().removeClass('has-error');
      }
    });

    $('#echeque').change(function() {
      var email = $('#email');
      if ($(this).is(':checked')) {
        email.rules("add", {required: true});
        email.valid();
      } else {
        email.rules("remove", "required");
        email.parent().removeClass('has-error');
      }
    });

    // phone mask
    if ($(".form-phone").length) {
      $(".form-phone").mask('+7 (999) 999-9999', {
        clearMaskOnLostFocus: true
      });
    }

    // Выбор времени доставки заказа во всплывающем окне
    $('.js-order-delivery-time-select-btn').on('click', function () {
      var $this = $(this),
        orderId = $this.data('order'),
        $timeSelect = $('.js-order-delivery-time-select').not('.hidden'),
        deliveryTime = $timeSelect.val(),
        deliveryTimeFull = $timeSelect.find('option:selected').text();

      if (deliveryTime !== '') {
        $('.js-order-delivery-time[data-order="' + orderId + '"]').val(deliveryTime);
        $('.js-order-delivery-time-btn[data-order="' + orderId + '"]').find('.cog__time').html(deliveryTimeFull);
        setOrderDeliveryTimeInfo(orderId, deliveryTime);
      }
    });

    $('.js-order-delivery-address-btn').on('click', function () {
      var $this = $(this),
        orderId = $this.data('order');

      let addrPopUp = $('#address-popup').find('#delivery');
      let isLocalCome = order.orderDeliveriesInfo[orderId].delivery_id === 3;
      addrPopUp.find('#housing-popup').val(isLocalCome ? '' : order.orderDeliveriesInfo[orderId].housing);
      addrPopUp.find('#entry').val(isLocalCome ? '' : order.orderDeliveriesInfo[orderId].entry);
      addrPopUp.find('#floor').val(isLocalCome ? '' : order.orderDeliveriesInfo[orderId].floor);
      addrPopUp.find('#flat').val(isLocalCome ? '' : order.orderDeliveriesInfo[orderId].flat);
      addrPopUp.find('#full_address_popup').text(isLocalCome ? '' : order.orderDeliveriesInfo[orderId].value);
      $('.js-order-delivery-popup-save-btn').data("order", orderId);
      if (!isLocalCome) {
        typeAddressPopup = 1;
        $('#address-popup').find('.form-group-btn.order-button-popup').css('display', 'block');
        $('#address-popup').find('#delivery_button_popup').parent('li').addClass('active');
        $('#address-popup').find('#delivery_button_popup').click();
        $('#address-popup').find('#come_button_popup').parent('li').removeClass('active');
      } else {
        $('#address-popup').find('#delivery_button_popup').parent('li').removeClass('active');
        $('#address-popup').find('#come_button_popup').click();
        $('#address-popup').find('#come_button_popup').parent('li').addClass('active');
      }
    });

    $('.js-order-delivery-time-btn').on('click', function () {
      var $this = $(this),
        orderId = $this.data('order'),
        todayOrder = $this.data('today-order'),
        orderSelectedDeliveryTime = $('.js-order-delivery-time[data-order="' + orderId + '"]').val();

      $('.js-order-delivery-time-select-btn').data("order", orderId);

      if (todayOrder) {
        $('.js-order-delivery-time-select[data-tomorrow]').addClass("hidden");
        $('.js-order-delivery-time-select[data-today]').removeClass("hidden").val(orderSelectedDeliveryTime);
      } else {
        $('.js-order-delivery-time-select[data-tomorrow]').removeClass("hidden");
        $('.js-order-delivery-time-select[data-today]').addClass("hidden").val(orderSelectedDeliveryTime);
      }
    });

    $('#address').keydown(function (e) {
      let keyDown = e.originalEvent.keyCode;
      let suggest = $('#ui-id-1');
      if ((keyDown === 9 || keyDown === 13) && suggest.length) {
        let autoSelected = suggest.find('li');
        if (autoSelected.length) {
          $(autoSelected[0]).click();
        } else {
          e.preventDefault();
        }
      }
    });

    /*    window.addEventListener("load", function () {
          startScrollbar();
        });*/


    $(".btn-next").click(function () {
      if (($('input[name=phone]').val().match(/^\+7\s\([0-9]{3}\)\s[0-9]{3}\-[0-9]{4}$/))
        && ($('#name').val().length >= 2)) {
        $(".step2-personal-data").hide(300);
        $(".step2-payment").show(300);
        $(".btn-next").hide();
        $(".btn-order").show();
        $("#order-steps > li").removeClass("active");
        $("#order-steps > li:last-child").addClass("active");
        $(".panel-order .order-sum").show(300);
        $(".btn-next").hide();
        $('.send_order').show();
      } else {
        $('#name').trigger('change');
        $('#phone').trigger('change');
        $('#email').trigger('change');
        $('.btn-order').trigger('click');
      }
    });

    $(document).on('click', '.x-delete-order', function (e) {
      e.preventDefault();
      let $el = $(this),
        orderId = $el.data('idorder');
      $.ajax({
        url: '/ajax/deleteOrder.php',
        method: 'POST',
        dataType: 'json',
        data: {
          orderId: orderId
        }
      }).done(function (data) {
        if (data.STATUS === 'OK') {
          window.location.href = '/personal/orders/';
        }
      });
    })

    function statusOrderUpdate() {
      let $update = $(document).find('.x-order-status-update');
      if ($update.length) {
        $.ajax({
          url: '/ajax/statusOrder.php',
          method: 'POST',
          data: {
            ORDER_ID: $update.attr('data-orderid')
          }
        }).done(function (data) {
          $(document).find('.x-order-status-box').html(data);
        });
      }

      if ($(document).find('.x-order-status-redirect').length) {
        location.replace("/personal/orders/");
      }
    }

    if ($(document).find('.x-order-status-box').length) {
      setInterval(statusOrderUpdate, 20000);
    }
  })
})(jQuery)


